import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { ConfirmationModal, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { routes } from '~/constants';
import { useIoContext } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import ExternalLinkButton from './ExternalLinkButton';
const deprecatedTestIds = {
    TerminateServiceModalTestIds: {
        Root: 'terminate-service-modal'
    }
};
export const GetTerminateServiceModalTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds
    });
export default function TerminateServiceModal(props) {
    const { serviceName, agreementId, stoppageMayAffectNextBill, canPauseService, onKeepService, onStopService } = props;
    const { t: commonTexts } = useLocaleKeys('common');
    const { t: terminateServiceModalTexts } = useLocaleKeys('components.terminateServiceModal');
    const { native } = useIoContext();
    const { TerminateServiceModalTestIds } = useMemo(()=>GetTerminateServiceModalTID(), []);
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'terminate_service_confirm'
            },
            secondaryButton: {
                name: 'terminate_service_cancel'
            }
        },
        title: terminateServiceModalTexts.title({
            serviceName
        }),
        skin: "danger",
        testId: TerminateServiceModalTestIds.Root(),
        content: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    children: terminateServiceModalTexts.areYouSure()
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    children: terminateServiceModalTexts.clientNoLongerCharged()
                }),
                stoppageMayAffectNextBill && /*#__PURE__*/ _jsx(Typography, {
                    children: terminateServiceModalTexts.removedFromNextBill()
                }),
                canPauseService && !native.isNative && /*#__PURE__*/ _jsxs(Typography, {
                    testId: TerminateServiceModalTestIds.PauseNote(),
                    style: {
                        marginBlockStart: 20
                    },
                    children: [
                        terminateServiceModalTexts.pauseNote(),
                        /*#__PURE__*/ _jsx(ExternalLinkButton, {
                            openInNewTab: true,
                            href: routes.billingHub(agreementId),
                            bi: {
                                name: 'terminate_service_billing_hub'
                            },
                            children: terminateServiceModalTexts.billingHub()
                        }),
                        terminateServiceModalTexts.pauseNoteSuffix()
                    ]
                })
            ]
        }),
        primaryButtonLabel: commonTexts.buttons.stopService(),
        onPrimaryButtonClick: ()=>onKeepService(),
        secondaryButtonLabel: commonTexts.buttons.keepService(),
        onSecondaryButtonClick: ()=>onStopService(),
        onCloseButtonClick: ()=>onStopService()
    });
}
